import { naturalShelfCodeCompare } from './floorLayouts';
import ShelfButton from './ShelfButton';
import { TShelves } from 'utils/types';

type GenericShelfGridProps = {
  shelves: TShelves[];
  selectedCode?: string | null;
  onSelectShelf: (code: string, shelf?: TShelves) => void;
};

const GenericShelfGrid = ({
  shelves,
  selectedCode,
  onSelectShelf
}: GenericShelfGridProps) => {
  const sorted = [...shelves].sort((a, b) =>
    naturalShelfCodeCompare(a.shelfCode, b.shelfCode)
  );

  if (sorted.length === 0) {
    return (
      <div className="text-body-tertiary py-6 text-center">
        No shelves in this space yet.
      </div>
    );
  }

  const shelvesByCode = Object.fromEntries(
    sorted.map(shelf => [shelf.shelfCode.toUpperCase(), shelf])
  );

  return (
    <div className="warehouse-floor-map">
      <div className="warehouse-shelf-grid">
        {sorted.map(shelf => (
          <ShelfButton
            key={shelf.shelfId}
            code={shelf.shelfCode}
            shelvesByCode={shelvesByCode}
            selectedCode={selectedCode}
            onSelect={onSelectShelf}
          />
        ))}
      </div>
    </div>
  );
};

export default GenericShelfGrid;
